module.exports = __webpack_public_path__ + "428be4ca306b453eee7f37bbf1060550.png";